// @flow
import React, { Component } from 'react'
import type { OptionType } from '../types'
import LocationsSelect from './LocationsSelect'
import LabeledWrapper from './LabeledWrapper'
import type { Location } from './LocationsSelect'

type Props = {|
  ajaxUrl: string,
  ajaxDelay: number,
  labelTitle: string,
  quickLocationOptions: Array<OptionType>,
  dropdownLocationOptions: Array<OptionType>,
  excludedLocationIds: Array<number>,
  errors: Array<string>,
  preloadedLocations: Array<Location>,
  onChange: Function,
  onLocationsLoad: Function
|}

export default class ExcludedLocationsSelect extends Component<Props> {
  render() {
    return (
      <LabeledWrapper label={this.props.labelTitle} twoLines>
        <LocationsSelect
          className="t-ExcludedLocationsSelect"
          errors={this.props.errors}
          quickLocationOptions={this.props.quickLocationOptions}
          dropdownLocationOptions={this.props.dropdownLocationOptions}
          locationIds={this.props.excludedLocationIds}
          preloadedLocations={this.props.preloadedLocations}
          ajaxUrl={this.props.ajaxUrl}
          ajaxDelay={this.props.ajaxDelay}
          locationType="excluded"
          onLocationsLoad={(locations) => this.props.onLocationsLoad(locations)}
          onChange={(ids) => this.props.onChange(ids)}
        />
      </LabeledWrapper>
    )
  }
}
